import { useEffect, useState } from 'react';
import { useAccountMediaUrl } from '../components/AccountMedia';
import { paletteFromPixels, type ImagePalette } from './imagePalette';

export function useImagePalette(source?:string):ImagePalette | null {
  const url=useAccountMediaUrl(source);
  const [result,setResult]=useState<{source:string;palette:ImagePalette|null}|null>(null);
  useEffect(()=>{
    if(!source || !url)return;
    let active=true;const image=new Image();image.crossOrigin='anonymous';
    image.onload=()=>{try{
      const canvas=document.createElement('canvas');canvas.width=canvas.height=40;
      const context=canvas.getContext('2d',{willReadFrequently:true});if(!context)return;
      context.drawImage(image,0,0,40,40);
      const palette=paletteFromPixels(context.getImageData(0,0,40,40).data);
      if(active)setResult({source,palette});
    }catch{if(active)setResult({source,palette:null});}};
    image.onerror=()=>{if(active)setResult({source,palette:null});};image.src=url;
    return()=>{active=false;image.onload=null;image.onerror=null;};
  },[source,url]);
  return result && result.source===source ? result.palette : null;
}
